module.exports = __webpack_public_path__ + "static/media/classroom.2f50a433.png";